import React, { useState } from 'react';
import UserRegistrationForm from '../../common/UserRegistrationForm';
import { useInvitationContext } from '../../../contexts/InvitationContext';
import type { UserRegistrationDetails } from '../../../types/Registration';

interface InvitationUserRegistrationProps {
  onSuccess: (message: string) => void;
  email: string;
  invitationToken: string;
}

const InvitationUserRegistration: React.FC<InvitationUserRegistrationProps> = ({ onSuccess, email, invitationToken }) => {
  const [localError, setLocalError] = useState<string | null>(null);
  const initialUserDetails: UserRegistrationDetails = {
    // Core Identity
    surname: '',
    fullNames: '',
    nickname: '',
    email: email,
    password: '',
    confirmPassword: '',
    idNumber: '',
    identificationType: 'RSA ID',
    dateOfBirth: '',
    gender: 'Male',
    
    // Contact
    mobileNumber: '',
    homeTelephone: '',
    
    // Physical Address
    unitNumber: '',
    complex: '',
    streetNumber: '',
    streetName: '',
    suburb: '',
    city: '',
    postalCode: '',
    
    // Postal Address
    postalUnitNumber: '',
    postalComplex: '',
    postalStreetNumber: '',
    postalStreetName: '',
    postalSuburb: '',
    postalCity: '',
    postalPostalCode: '',   

    // Legal Agreements
    agreedTerms: false,
    agreedPOPIA: false,
  };

  const { registerAndAcceptInvitation, isLoading, error } = useInvitationContext();

  const handleSubmit = async (data: UserRegistrationDetails) => {
    setLocalError(null);
    try {
      const result = await registerAndAcceptInvitation(data, invitationToken);
      if (result.success) {
        onSuccess(result.message || 'Account created and invitation accepted successfully!');
      } else {
        const errorMsg = result.error || 'Registration failed. Please try again.';
        setLocalError(errorMsg);
        console.error('Registration failed:', errorMsg);
      }
    } catch (err) {
      const errorMsg = 'An unexpected error occurred. Please try again.';
      setLocalError(errorMsg);
      console.error('Registration failed:', err);
    }
  };

  return (
    <UserRegistrationForm
      mode="invitation"
      initialData={initialUserDetails}
      onSubmit={handleSubmit}
      title="Complete Your Account"
      description="Welcome! Please complete your account details to accept the invitation."
      submitButtonText={isLoading ? "Creating Account..." : "Create Account"}
      emailReadonly={true}
      error={localError || error}
    />
  );
};

export default InvitationUserRegistration;